import { defineFieldFormInterface } from "~/entities/field";
import InterfaceSelectDropdownStringType from "./InterfaceSelectDropdownStringType.vue";

export default defineFieldFormInterface({
  interface: "select-dropdown",
  type: "string",
  component: InterfaceSelectDropdownStringType,
});
